import api from "../services/authService";

// The whole navigation tree in one call — it is small, and having it up
// front lets the sidebar and the landing page render without a request
// per section.
export const fetchHelpSections = () => api.get("/help/sections/");

export const searchHelp = (query) =>
  api.get("/help/search/", { params: { q: query } });

// Slugs contain a slash ("submit-to-va/overview"), which the backend
// route accepts as a path segment.
export const fetchHelpArticle = (slug) => api.get(`/help/articles/${slug}/`);
